seedWebControllers.controller('IntegrationLogModalCtrl', ['$scope', '$uibModalInstance', '$timeout', 'translation', 'logger', 'logMsg',
    function ($scope, $uibModalInstance, $timeout, translation, logger, logMsg) {

        //$scope.scopeItem = scopeItem;
        //$scope.propertyToRead = propertyToRead;
        $scope.translation = translation;

        $scope.logMsg = logMsg;
        $scope.logger = logger;

        $scope.save = function () {
            $uibModalInstance.close($scope.scopeItem);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }
]);